import { render, staticRenderFns } from "./NcnEditDialog.vue?vue&type=template&id=22737686&scoped=true&"
import script from "./NcnEditDialog.vue?vue&type=script&lang=js&"
export * from "./NcnEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22737686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22737686')) {
      api.createRecord('22737686', component.options)
    } else {
      api.reload('22737686', component.options)
    }
    module.hot.accept("./NcnEditDialog.vue?vue&type=template&id=22737686&scoped=true&", function () {
      api.rerender('22737686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/NcnEditDialog.vue"
export default component.exports